import classNames from 'classnames'
import React from 'react'

import EcommerceTracking from '../../tracking/ecommerce'
import { EcommerceProvider } from '~/contexts/ecommerce-context'
import { usePageContext } from '~/contexts/page-context'
import { useInBucket } from '~/hooks/use-in-bucket'

import P0 from './deal-card'
import styles from './styles.module.css'

const P0Container = ({ p0, currentProvider, postcode, address }) => {
  const { listnames } = usePageContext()

  const list = listnames().p0

  const isBlackFriday = useInBucket('experiment-black-friday-2023', 'variant')

  return (
    <div
      className={classNames('us-col-md-5', styles.p0Container, {
        [styles.blackFriday]: isBlackFriday
      })}
    >
      <EcommerceProvider
        value={{
          address,
          comparisonId: p0.comparisonId,
          currentProvider,
          deals: p0.display.deal,
          sort: 'HERO',
          list,
          metadata: { dimension94: currentProvider ? `broadband:${currentProvider}` : undefined },
          postcode
        }}
      >
        <EcommerceTracking
          comparison={p0.display.deal}
          comparisonId={p0.comparisonId}
          sort={'HERO'}
          list={list}
          metadata={{ dimension94: currentProvider ? `broadband:${currentProvider}` : undefined }}
        >
          <P0 key={'p0'} deal={p0.display.deal} p0={p0} />
        </EcommerceTracking>
      </EcommerceProvider>
    </div>
  )
}

export default P0Container
